import { render } from "./Image.vue?vue&type=template&id=69a4ec66&scoped=true&bindings={\"src\":\"props\",\"className\":\"props\",\"alt\":\"props\"}"
import script from "./Image.vue?vue&type=script&lang=js"
export * from "./Image.vue?vue&type=script&lang=js"

import "./Image.vue?vue&type=style&index=0&id=69a4ec66&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-69a4ec66"

export default script